module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/2-on-3189cfeefcf9d88a8cbef4c6cac40a51.png";